// extracted by mini-css-extract-plugin
export default {"errorMessage":"NotFound_errorMessage__fs59H"};